/**
 * DevExtreme (esm/__internal/grids/grid_core/keyboard_navigation/dom.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import {
    ATTRIBUTES
} from "./const";
const isDragCell = $cell => void 0 !== $cell.attr(ATTRIBUTES.dragCell);
const getFocusableCellSelector = columnIndex => [`[${ATTRIBUTES.ariaColIndex}="${columnIndex+1}"]`, `:not([${ATTRIBUTES.dragCell}])`, ":not([aria-hidden=true])"].join("");
const getCellToFocus = ($cellElements, columnIndex) => $cellElements.filter(getFocusableCellSelector(columnIndex)).first();
export const GridCoreKeyboardNavigationDom = {
    isDragCell: isDragCell,
    getCellToFocus: getCellToFocus
};
